"use strict";
import { migrateLpPosition } from "data/apiClients/tradingApi/TradingApiClient";
import { parseErrorMessageTitle } from "features/transactions/liquidity/utils";
import { TransactionStepType } from "features/transactions/steps/types";
import {
  validateTransactionRequest
} from "features/transactions/swap/utils/trade";
export function createMigratePositionStep(txRequest) {
  return {
    type: TransactionStepType.MigratePositionTransaction,
    txRequest
  };
}
export function createMigratePositionAsyncStep(migratePositionRequestArgs, signatureDeadline) {
  return {
    type: TransactionStepType.MigratePositionTransactionAsync,
    getTxRequest: async (signature) => {
      if (!migratePositionRequestArgs || !signatureDeadline) {
        return void 0;
      }
      try {
        const { migrate } = await migrateLpPosition({
          ...migratePositionRequestArgs,
          signature,
          signatureDeadline
        });
        return validateTransactionRequest(migrate);
      } catch (e) {
        throw new Error("migrate failed to get transaction request", {
          cause: parseErrorMessageTitle(e, { includeRequestId: true })
        });
      }
    }
  };
}
